export default __webpack_public_path__ + "static/media/weight_blue.8e6cccd3.svg";